window.SidebarUtils = {
  activate(href) {
    if (($(window).width() > 1024) && ($(href).length > 0)) {
      SidebarUtils.setState(true);
      $(`a[href='${href}']`).exists()[0].click();
    }
  },

  toggleState() {
    const isEnabled = $("body").hasClass("sidebar-expanded");
    $("body").toggleClass("sidebar-expanded");
    if ($(window).width() > 1024) {
      $.cookie('sideBarEnabled', !isEnabled); 
    }
    $(document).trigger('sidebar-toggled');
  },

  setState(value = undefined) {
    if (value === undefined) {
      value = ($(window).width() > 1024) && ($.cookie('sideBarEnabled') === null) || ($.cookie('sideBarEnabled') === "true");
    }

    $("body").toggleClass("sidebar-expanded", value);
    if (value) {
      $(document).trigger('sidebar-toggled');
    }
  }
};